'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ARTICLE_REQUEST = exports.ARTICLE_REQUEST = 'ARTICLE_REQUEST';
var ARTICLE_SUCCESS = exports.ARTICLE_SUCCESS = 'ARTICLE_SUCCESS';
var ARTICLE_FAILURE = exports.ARTICLE_FAILURE = 'ARTICLE_FAILURE';
//# sourceMappingURL=types.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/redux-article/lib/cjs/types.js
 ** module id = 177
 ** module chunks = 1
 **/